import {
  APICallState,
  CaesarsButton,
  PanelContainer,
  ToastMessageContentItemType,
  ToastType,
  Toast,
} from '@eCommerce/frontend-legacy-shared-library-native';
import {Text, View} from 'native-base';
import React, {useEffect} from 'react';
import PaymentMethod from 'components/PaymentMethod';
import {PaymentCardInfo} from 'store/payments/payments.reducer';
import {scrollToContentTop} from 'screens/Profile';
import CreditCardCTA from './CreditCardCTA';
import {useSelector} from 'Provider';

export interface PaymentInfoModuleProps {
  savedCards: PaymentCardInfo[];
  handleDeletePayment: (card: PaymentCardInfo) => void;
  onAddPayment?: () => void;
  deleteCardCallState?: APICallState;
  getAllCardsCallState?: APICallState;
  onResetDeleteCardCallState?: () => void;
}

const PaymentInfoModule = (props: PaymentInfoModuleProps) => {
  const {
    savedCards,
    handleDeletePayment,
    onAddPayment,
    deleteCardCallState,
    getAllCardsCallState,
    onResetDeleteCardCallState,
  } = props;

  useEffect(() => {
    if (deleteCardCallState === APICallState.ERROR) {
      scrollToContentTop();
    }
  }, [deleteCardCallState]);

  let index = 1;

  const shouldShowIndex = (card: PaymentCardInfo) => {
    if (savedCards.length === 1 || card.cardNickname) {
      return false;
    }
    if (savedCards.filter(c => !c.cardNickname).length < 2) {
      return false;
    }
    return true;
  };

  return (
    <PanelContainer
      icon="credit-card"
      panelTitle="SAVED PAYMENT METHODS"
      contentMaxWidth="100%"
      isLoading={
        deleteCardCallState === APICallState.LOADING ||
        getAllCardsCallState === APICallState.LOADING
      }>
      <Text mb="48px">
        You&apos;re ready to play. See your payment method(s) below.
      </Text>
      {deleteCardCallState === APICallState.ERROR && (
        <View mb="8px">
          <Toast
            toast={{
              type: ToastType.DANGER,
              messageContent: [
                {
                  elementType: ToastMessageContentItemType.TEXT,
                  text: 'There was an error while deleting your card',
                },
              ],
            }}
            onRemove={onResetDeleteCardCallState}
          />
        </View>
      )}
      <View marginBottom="32px">
        {savedCards?.map((savedCard, i) => (
          <View key={`payment-method-${i}`}>
            <PaymentMethod
              savedCard={savedCard}
              onDeletePayment={handleDeletePayment}
              index={shouldShowIndex(savedCard) ? index++ : undefined}
            />
            {i < savedCards.length - 1 && <View h="16px" />}
          </View>
        ))}
        {/* <Text mt="32px">
          Note: Card on file not available at Windsor, Tropicana Atlantic City,
          Tropicana Laughlin and Circus Circus at THE ROW
        </Text> */}
      </View>
      <CaesarsButton title="Add A New Payment" onPress={onAddPayment} />
    </PanelContainer>
  );
};

export default PaymentInfoModule;
